import type { EmailAddress } from '@wtfalch/email/mailbox';

import { isAddress } from './format.ts';

const domainOf = (email: string) => email.slice(email.lastIndexOf('@') + 1).toLowerCase();

/** Whether `email` is at the same company as `own`: the same domain. */
export function isColleague(email: string, own: string): boolean {
  return own.includes('@') && email.includes('@') && domainOf(email) === domainOf(own);
}

/**
 * The recipients as chips, tinted by who they are: a colleague at the
 * sender's own company, or somebody outside it. The word "outside" is on the
 * chip too, so the difference is not carried by the tint alone.
 */
export function RecipientChips({
  recipients,
  own,
}: {
  recipients: readonly EmailAddress[];
  own: string;
}) {
  const valid = recipients.filter((r) => isAddress(r.email));
  if (valid.length === 0 || !own) return null;
  return (
    <ul className="flex items-center gap-2 flex-wrap mail-chips" aria-label="Who this goes to">
      {valid.map((r) => {
        const colleague = isColleague(r.email, own);
        return (
          <li
            key={r.email}
            className={colleague ? 'chip c-colleague' : 'chip c-outside'}
            data-kind={colleague ? 'colleague' : 'outside'}
          >
            <span>{r.name || r.email}</span>
            {!colleague && <span className="mail-chip-note">outside</span>}
          </li>
        );
      })}
    </ul>
  );
}
